import React from 'react';
import { Link } from 'react-router-dom';
import ProductListSlider from './product_list_slider';
import useProductByCategory from '../../hooks/use_product_by_category';

export default function ProductListTrend() {
   const { products } = useProductByCategory('Xu hướng 2026');
   return (
      <div className="layout-container !mt-6">
         <div className="bg-[#fe7902] flex flex-col items-center">
            <img src="/banner-xu-huong-home.webp" alt="" className="object-cover" />
            <div className="w-full p-3">
               <ProductListSlider products={products} />
            </div>
            <Link
               to={'/category/Xu hướng 2026'}
               className="rounded-md bg-white text-[#418fde] text-[14px] px-8 py-2 font-[500] mb-4 mt-1"
            >
               Khám phá xu hướng 2026
            </Link>
         </div>
      </div>
   );
}